export const province = [
  { id: 'AB', value: 'AB', label: 'Alberta' },
  { id: 'BC', value: 'BC', label: 'British Columbia' },
  { id: 'MB', value: 'MB', label: 'Manitoba' },
  { id: 'NB', value: 'NB', label: 'New Brunswick' },
  { id: 'NL', value: 'NL', label: 'Newfoundland' },
  { id: 'NS', value: 'NS', label: 'Nova Scotia' },
  { id: 'NU', value: 'NU', label: 'Nunavut' },
  { id: 'NWT', value: 'NWT', label: 'Northwest Territories' },
  { id: 'ON', value: 'ON', label: 'Ontario' },
  { id: 'PEI', value: 'PEI', label: 'Prince Edward Island' },
  { id: 'SK', value: 'SK', label: 'Saskatchewan' },
  { id: 'QC', value: 'QC', label: 'Quebec' },
  { id: 'YK', value: 'YK', label: 'Yukon' },
];
export const provinceReport = [
  { id: 'AB', value: 'AB', label: 'Alberta' },
  { id: 'BC', value: 'BC', label: 'British Columbia' },
  { id: 'MB', value: 'MB', label: 'Manitoba' },
  { id: 'NB', value: 'NB', label: 'New Brunswick' },
  { id: 'NL', value: 'NL', label: 'Newfoundland' },
  { id: 'NS', value: 'NS', label: 'Nova Scotia' },
  { id: 'NU', value: 'NU', label: 'Nunavut' },
  { id: 'NWT', value: 'NWT', label: 'Northwest Territories' },
  { id: 'ON', value: 'ON', label: 'Ontario' },
  { id: 'PEI', value: 'PEI', label: 'Prince Edward Island' },
  { id: 'SK', value: 'SK', label: 'Saskatchewan' },
  { id: 'QC', value: 'QC', label: 'Quebec' },
  { id: 'YK', value: 'YK', label: 'Yukon' },
  { id: 'Alberta', value: 'Alberta', label: 'Alberta' },
  { id: 'BritishColumbia', value: 'British Columbia', label: 'British Columbia' },
  { id: 'Manitoba', value: 'Manitoba', label: 'Manitoba' },
  { id: 'NewBrunswick', value: 'New Brunswick', label: 'New Brunswick' },
  { id: 'Newfoundland', value: 'Newfoundland', label: 'Newfoundland' },
  { id: 'NovaScotia', value: 'Nova Scotia', label: 'Nova Scotia' },
  { id: 'Nunavut', value: 'Nunavut', label: 'Nunavut' },
  { id: 'NorthwestTerritories', value: 'Northwest Territories', label: 'Northwest Territories' },
  { id: 'Ontario', value: 'Ontario', label: 'Ontario' },
  { id: 'PrinceEdwardIsland', value: 'Prince Edward Island', label: 'Prince Edward Island' },
  { id: 'Saskatchewan', value: 'Saskatchewan', label: 'Saskatchewan' },
  { id: 'Quebec', value: 'Quebec', label: 'Quebec' },
  { id: 'Yukon', value: 'Yukon', label: 'Yukon' },
];